type ConsumerServiceSubCategory = {
  slug: string;
  name: string;
  categorySlug: string;
  uniqueSlug: string;
  description?: string;
  sortOrder: number;
  hidden: boolean;
};
export const consumerServiceSubCategories: ReadonlyArray<ConsumerServiceSubCategory> = [
  {
    sortOrder: 1,
    name: 'Allergies',
    description: '',
    categorySlug: 'childrens',
    slug: 'allergies',
    uniqueSlug: 'childrens/allergies',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Physicals & exams',
    description: '',
    categorySlug: 'childrens',
    slug: 'physicals',
    uniqueSlug: 'childrens/physicals',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'Sickness & injury',
    description: '',
    categorySlug: 'childrens',
    slug: 'sickness-injury',
    uniqueSlug: 'childrens/sickness-injury',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'Skin health',
    description: '',
    categorySlug: 'childrens',
    slug: 'skin-health',
    uniqueSlug: 'childrens/skin-health',
    hidden: false,
  },
  {
    sortOrder: 5,
    name: 'Vaccinations',
    description: '',
    categorySlug: 'childrens',
    slug: 'vaccinations',
    uniqueSlug: 'childrens/vaccinations',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Asthma',
    description: '',
    categorySlug: 'chronic',
    slug: 'asthma',
    uniqueSlug: 'chronic/asthma',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Autoimmune conditions',
    description: '',
    categorySlug: 'chronic',
    slug: 'autoimmune',
    uniqueSlug: 'chronic/autoimmune',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'Diabetes',
    description: '',
    categorySlug: 'chronic',
    slug: 'diabetes',
    uniqueSlug: 'chronic/diabetes',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'Gout',
    description: '',
    categorySlug: 'chronic',
    slug: 'gout',
    uniqueSlug: 'chronic/gout',
    hidden: false,
  },
  {
    sortOrder: 5,
    name: 'Heart conditions',
    description: '',
    categorySlug: 'chronic',
    slug: 'heart-conditions',
    uniqueSlug: 'chronic/heart-conditions',
    hidden: false,
  },
  {
    sortOrder: 6,
    name: 'Respiratory conditions',
    description: '',
    categorySlug: 'chronic',
    slug: 'respiratory',
    uniqueSlug: 'chronic/respiratory',
    hidden: false,
  },
  {
    sortOrder: 7,
    name: 'Thyroid disease',
    description: '',
    categorySlug: 'chronic',
    slug: 'thyroid',
    uniqueSlug: 'chronic/thyroid',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'COVID-19 tests',
    description: '',
    categorySlug: 'covid',
    slug: 'covid-test',
    uniqueSlug: 'covid/covid-test',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'COVID-19 treatment',
    description: '',
    categorySlug: 'covid',
    slug: 'covid-treatment',
    uniqueSlug: 'covid/covid-treatment',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'COVID-19 vaccines',
    description: '',
    categorySlug: 'covid',
    slug: 'covid-vaccines',
    uniqueSlug: 'covid/covid-vaccines',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Allergies',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'allergies',
    uniqueSlug: 'illness-infection/allergies',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Cold, strep, sinus infection & flu symptoms',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'cold-strep-sinus-flu',
    uniqueSlug: 'illness-infection/cold-strep-sinus-flu',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'COVID-19',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'covid-19',
    uniqueSlug: 'illness-infection/covid-19',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'Dehydration & heat exhaustion',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'dehydration-heat-exhaustion',
    uniqueSlug: 'illness-infection/dehydration-heat-exhaustion',
    hidden: false,
  },
  {
    sortOrder: 5,
    name: 'Eye & ear infections',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'eye-ear',
    uniqueSlug: 'illness-infection/eye-ear',
    hidden: false,
  },
  {
    sortOrder: 6,
    name: 'Mounth ulcers (canker & cold sores)',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'mouth-ulcers',
    uniqueSlug: 'illness-infection/mouth-ulcers',
    hidden: false,
  },
  {
    sortOrder: 7,
    name: 'Sexually transmitted infections (STIs)',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'sti',
    uniqueSlug: 'illness-infection/sti',
    hidden: false,
  },
  {
    sortOrder: 8,
    name: 'Skin infections',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'skin-infection',
    uniqueSlug: 'illness-infection/skin-infection',
    hidden: false,
  },
  {
    sortOrder: 9,
    name: 'Stomach & digestive issues',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'stomach-digestive',
    uniqueSlug: 'illness-infection/stomach-digestive',
    hidden: false,
  },
  {
    sortOrder: 10,
    name: 'Urinary tract (UTI) & bladder infections',
    description: '',
    categorySlug: 'illness-infection',
    slug: 'uti',
    uniqueSlug: 'illness-infection/uti',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Aches & pains',
    description: '',
    categorySlug: 'injury-pain',
    slug: 'aches-pains',
    uniqueSlug: 'injury-pain/aches-pains',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Bites & stings',
    description: '',
    categorySlug: 'injury-pain',
    slug: 'bites-stings',
    uniqueSlug: 'injury-pain/bites-stings',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'Burns & blisters',
    description: '',
    categorySlug: 'injury-pain',
    slug: 'burns-blisters',
    uniqueSlug: 'injury-pain/burns-blisters',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'Cuts, abbrasions & wounds',
    description: '',
    categorySlug: 'injury-pain',
    slug: 'cuts-wounds',
    uniqueSlug: 'injury-pain/cuts-wounds',
    hidden: false,
  },
  {
    sortOrder: 5,
    name: 'Foreign body removal',
    description: '',
    categorySlug: 'injury-pain',
    slug: 'foreign-removal',
    uniqueSlug: 'injury-pain/foreign-removal',
    hidden: false,
  },
  {
    sortOrder: 6,
    name: 'Sprains, strains & broken bones',
    description: '',
    categorySlug: 'injury-pain',
    slug: 'sprains-strains-breaks',
    uniqueSlug: 'injury-pain/sprains-strains-breaks',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Allergies',
    description: '',
    categorySlug: 'labs',
    slug: 'allergies',
    uniqueSlug: 'labs/allergies',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'DNA tests',
    description: '',
    categorySlug: 'labs',
    slug: 'dna',
    uniqueSlug: 'labs/dna',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'Energy & weight',
    description: '',
    categorySlug: 'labs',
    slug: 'energy-weight',
    uniqueSlug: 'labs/energy-weight',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'General health & wellness',
    description: '',
    categorySlug: 'labs',
    slug: 'health-wellness',
    uniqueSlug: 'labs/health-wellness',
    hidden: false,
  },
  {
    sortOrder: 5,
    name: 'Sexual health',
    description: '',
    categorySlug: 'labs',
    slug: 'sexual-health',
    uniqueSlug: 'labs/sexual-health',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Medical imaging',
    description: '',
    categorySlug: 'imaging',
    slug: 'medical-imaging',
    uniqueSlug: 'imaging/medical-imaging',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'LGBTQ+ care',
    description: '',
    categorySlug: 'mens-womens',
    slug: 'lgbtq-care',
    uniqueSlug: 'mens-womens/lgbtq-care',
    hidden: true,
  },
  {
    sortOrder: 2,
    name: "Men's health",
    description: '',
    categorySlug: 'mens-womens',
    slug: 'mens-health',
    uniqueSlug: 'mens-womens/mens-health',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: "Women's health",
    description: '',
    categorySlug: 'mens-womens',
    slug: 'womens-health',
    uniqueSlug: 'mens-womens/womens-health',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'Sexually transmitted infections (STIs)',
    description: '',
    categorySlug: 'mens-womens',
    slug: 'sti',
    uniqueSlug: 'mens-womens/sti',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Physicals & exams',
    description: '',
    categorySlug: 'exams-screenings',
    slug: 'physicals-exams',
    uniqueSlug: 'exams-screenings/physicals-exams',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Tests & screenings',
    description: '',
    categorySlug: 'exams-screenings',
    slug: 'tests-screenings',
    uniqueSlug: 'exams-screenings/tests-screenings',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'Occupational medicine',
    description: '',
    categorySlug: 'exams-screenings',
    slug: 'occupational-medicine',
    uniqueSlug: 'exams-screenings/occupational-medicine',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Acne, rosacea, eczema & psoriasis',
    description: '',
    categorySlug: 'skin-health',
    slug: 'acne-rosacea-eczema-psoriasis',
    uniqueSlug: 'skin-health/acne-rosacea-eczema-psoriasis',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Burns, blisters & wounds',
    description: '',
    categorySlug: 'skin-health',
    slug: 'burns-blisters-wounds',
    uniqueSlug: 'skin-health/burns-blisters-wounds',
    hidden: false,
  },
  {
    sortOrder: 3,
    name: 'Cysts & abscesses',
    description: '',
    categorySlug: 'skin-health',
    slug: 'cysts-abscesses',
    uniqueSlug: 'skin-health/cysts-abscesses',
    hidden: false,
  },
  {
    sortOrder: 4,
    name: 'Rashes, bug bites & warts',
    description: '',
    categorySlug: 'skin-health',
    slug: 'rash-bites-warts',
    uniqueSlug: 'skin-health/rash-bites-warts',
    hidden: false,
  },
  {
    sortOrder: 5,
    name: 'Splinter, stitch & staple removal',
    description: '',
    categorySlug: 'skin-health',
    slug: 'splinter-stitch-staple',
    uniqueSlug: 'skin-health/splinter-stitch-staple',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Disease prevention',
    description: '',
    categorySlug: 'vaccines',
    slug: 'disease-prevention',
    uniqueSlug: 'vaccines/disease-prevention',
    hidden: false,
  },
  {
    sortOrder: 2,
    name: 'Travel vaccines',
    description: '',
    categorySlug: 'vaccines',
    slug: 'travel',
    uniqueSlug: 'vaccines/travel',
    hidden: false,
  },
  {
    sortOrder: 1,
    name: 'Alma',
    description: '',
    categorySlug: 'mental-health',
    slug: 'alma',
    uniqueSlug: 'mental-health/alma',
    hidden: false,
  },
];
